import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { Heading, Button } from '@restworld/ui-ds-base';

import { useApplicationModalToggle } from '../form-inputs.hooks';

interface IWizardConfirmModalProps {
  handleCompleteProfile: () => void;
}
export const WizardConfirmModal: React.FunctionComponent<IWizardConfirmModalProps> = ({ handleCompleteProfile }) => {
  const { closeModal } = useApplicationModalToggle();
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <Heading size={1} align="center" weight="bold">
          {t('common:do_you_want_complete_your_profile')}
        </Heading>
        <Heading size={5} align="center" color="muted" weight="normal">
          {t('onboarding-page:suggest_positions_in_with_your_needs')}
        </Heading>
      </div>
      <div className="flex flex-col gap-4 w-full justify-center items-center">
        <Button fullwidth onClick={handleCompleteProfile}>
          {t('common:complete_profile')}
        </Button>
        <Button fullwidth variant="secondary-neutral" onClick={closeModal}>
          {router?.['query']?.['id'] ? t('common:return_to_location') : t('common:come_back')}
        </Button>
      </div>
    </div>
  );
};
export default WizardConfirmModal;
